// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CanonicalAddress,
} from "./types";


export default __t.row({
  id: __t.uuid(),
  brand: __t.uuid(),
  googlePlaceId: __t.string().name("google_place_id"),
  googlePlacePhotoName: __t.option(__t.string()).name("google_place_photo_name"),
  get canonicalAddress() {
    return CanonicalAddress.name("canonical_address");
  },
  confirmed: __t.bool(),
});
